import { Button } from 'antd';
import styled from 'styled-components';

import { Icon } from 'components/Icon';

export const ButtonWithIcon = styled(Button)`
  display: flex;
  align-items: center;
  gap: 0.5em;
`;

export const ButtonIcon = styled(Icon)`
  margin-right: 0.5em;
`;
